import { useTranslation } from 'react-i18next';
import { RhfImageField, type RhfImageFieldProps } from './shared/RhfImageField';

export type LogoFieldProps = Omit<RhfImageFieldProps, 'label' | 'imageOnly'> & {
  label?: string;
};

/**
 * `LogoField` — RHF-bound image upload for `Org.logo`. Image-only
 * dropzone (PDFs are intentionally rejected — a logo is always a
 * raster image).
 *
 * Backend wiring:
 *  - Reads/writes `OrganizationProfile.logo: ImageWithUpload`.
 *  - On save, the `OrgProfileService.applyLogo()` path uploads the
 *    file to Cloudinary under the `org_logo` folder and stamps
 *    `Org.logo` with the resulting `{ id, url }` slot. Subsequent
 *    fetches return the persisted slot so the thumbnail keeps
 *    showing without re-uploading.
 */
export function LogoField(props: LogoFieldProps) {
  const { t } = useTranslation('m-organization');
  return (
    <RhfImageField
      {...props}
      imageOnly
      label={props.label ?? t('form.logo.title')}
      placeholder={props.placeholder ?? t('form.logo.placeholder')}
      helper={props.helper ?? t('form.logo.helper')}
      uploadLabel={props.uploadLabel ?? t('form.logo.placeholder')}
    />
  );
}
